<template>
  <div id="LuckyWheel" :style="'width:'+width+';height:'+height">
    <div id="Outermost" :style="blocks[0]?blocks[0]:{}">
      <div id="middle" :style="blocks[1]?blocks[1]:{}">
        <div id="content" :style="blocks[2]?blocks[2]:{}">
            <div class='slice' v-for="(v,k) in prizes" :key="k" :style="'transform:rotate('+baseAngle*Number(k+1)+'deg)'" >
              <div class="award" :style="'transform: rotate(66deg) translateX(28px);'" >
                <p>{{v.item.name}}</p>
                <img :src="v.item.url" alt="" style="width:36px;margin-top:5px">
              </div>
            </div>
            <img src="@/assets/images/scan/point.png" alt="" class="point">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, watch } from "@vue/runtime-core";
export default {
  name: "luckywheel",
  props: {
    width: {
      type: [String, Number],
      default: "",
    },
    height: {
      type: [String, Number],
      default: "",
    },
    blocks: {
      type: Array,
      default: () => [{}],
    },
    prizes: {
      type: Array,
      default: () => [],
    },
    buttons: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    // 渲染 奖项
    const baseAngle=computed({
      get(){
        return 360/props.prizes.length
      }
    })
    return {
      baseAngle
    };
  },
};
</script>
<style lang="less" scoped>
#LuckyWheel {
  border-radius: 50%;
  overflow: hidden;
  #Outermost {
    width: 100%;
    height: 100%;
    border-radius: 100%;
    overflow: hidden;
    #middle {
      width: 100%;
      height: 100%;
      border-radius: 100%;
      overflow: hidden;
      #content {
        width: 100%;
        height: 100%;
        border-radius: 100%;
        position: relative;
        overflow: hidden;
         counter-reset: section;
        .point{
          width: 70px;
          position: absolute;
          z-index: 10;
          left: 50%;
          top: calc(50% - 15px);
          transform: translate(-50%,-50%);
        }
          .slice{
            position: absolute;
            transform-origin: 0% 100%;
            // overflow: hidden;
            top: 0;
            right: 0;
            width:50%;
            height:50%;
            background-color: transparent;
            padding-top: 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            font-size: 13px;
            border-bottom: 2px solid #C0260F;
            color: rgb(186, 47, 35);
            &:nth-child(1){z-index: 8;}
            &:nth-child(2){z-index: 7;}
            &:nth-child(3){z-index: 6;}
            &:nth-child(4){z-index: 5;}
            &:nth-child(5){z-index: 4;}
            &:nth-child(6){z-index: 3;}
            &:nth-child(7){z-index: 2;}
            &:nth-child(8){z-index: 1;}

            >div{
              position: absolute;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              img{
                margin-top: 5px;
              }
            }
            //    display: flex;
            // flex-direction: column;
            // align-items: center;
            // justify-content: center;
          }
      }
    }
  }
  #buttonsOutermost {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%, -50%);
    background-color: #000;
  }
}
</style>